import * as server from "@/utils/http"

export const getAllTenant = params =>
  server.get("/tenant/findAll?", params); // 列表


/**
 * 根据省份获取城市
 * @param params
 * @returns {*}
 */
export const getCityByProvince = params =>
  server.get("/tenant/findByProvinceCode?", params); // 列表


/**
 * 根据城市获取区域
 * @param params
 * @returns {*}
 */
export const getAreaByCity = params =>
  server.get("/tenant/findByCityCode?", params); // 列表


/**
 * 根据区号获取街道
 * @param params
 * @returns {*}
 */
export const getStreetByArea = params =>
  server.get("/tenant/findByAreaCode?", params); // 列表


export const getAllProvince = params =>
  server.get("/tenant/findProvince?", params); // 列表

/**
 * 根据街道获取菜单
 * @param params
 * @returns {*}
 */
export const getAllCode = params =>
  server.get("/tenant/findByCode", params); // 列表

export const findChildByCode = params =>
  server.get("/tenant/findChlidByCode", params); // 列表




